import { render, staticRenderFns } from "./TeacherNeedToChangeLessonNotification.vue?vue&type=template&id=69dcff29&"
import script from "./TeacherNeedToChangeLessonNotification.vue?vue&type=script&lang=js&"
export * from "./TeacherNeedToChangeLessonNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports